import React from 'react';
import { Check, X } from 'lucide-react';

export const PASSWORD_RULES = 'Minimum 6 characters with at least 1 capital letter, 1 number and 1 special character.';

const CHECKS = [
  { id: 'len', label: '6+ characters', test: (v) => v.length >= 6 },
  { id: 'upper', label: '1 capital letter', test: (v) => /[A-Z]/.test(v) },
  { id: 'digit', label: '1 number', test: (v) => /[0-9]/.test(v) },
  { id: 'special', label: '1 special character', test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export const passwordProblem = (v = '') => {
  const failed = CHECKS.filter((c) => !c.test(v));
  return failed.length ? `Password needs: ${failed.map((c) => c.label).join(', ')}.` : '';
};

export const PasswordHint = ({ value = '' }) => (
  <ul className="flex flex-wrap gap-x-3 gap-y-1 text-[11px]" data-testid="password-hint" aria-live="polite">
    {CHECKS.map((c) => {
      const ok = c.test(value);
      return <li key={c.id} className={`flex items-center gap-1 ${ok ? 'text-emerald-600' : 'text-slate-500'}`} data-testid={`pw-rule-${c.id}`}>{ok ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}{c.label}</li>;
    })}
  </ul>
);
